import { Component, OnInit } from '@angular/core';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { SidenavService } from '../../services/sidenav.service';
import { DashboardService } from 'src/app/pages/user/dashboard/services/dashboard.service';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { BankService } from 'src/app/pages/user/profile/services/bank.service';
import { FundraiserService } from 'src/app/pages/fundraiser/services/fundraiser.service';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { NgIf, NgStyle } from '@angular/common';
import { MatListModule } from '@angular/material/list';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    standalone: true,
    imports: [MatListModule, NgIf, MatMenuModule, MatTooltipModule, NgStyle, ExtendedModule]
})
export class SidenavComponent implements OnInit {
	isShowText: Boolean = false;
	isShowIcon: Boolean = false;
	isReceiver: Boolean = true;
	activeItem: string = '';
	dashboardTooltip = $localize`:@@button_dashboard:Dashboard`;
	fundraisersTooltip = $localize`:@@my_funraisers_view_label:My Fundraisers`;
	donationsTooltip = $localize`:@@donations_zero_donation_heading:Donations`;
	balanceTooltip = $localize`:@@header_userMenu_button_balance:Balance`;
	payoutsettingsTooltip = $localize`:@@profile_payoutSettings:Payout Settings`;
	emailsettingsTooltip = $localize`:@@profile_emailSettings_label:Email Settings`;
	customisefundraisersTooltip = $localize`:@@header_userMenu_button_customiseFundraisers:Customise Fundraisers`;
	customiseemailsTooltip = $localize`:@@header_userMenu_button_customiseEmails:Customise Emails`;
	customisereceiptsTooltip = $localize`:@@header_userMenu_button_customiseReceipts:Customise Receipts`;
	apikeyTooltip = $localize`:@@header_userMenu_button_apiKey:API-Key`;
	widgetTooltip = $localize`:@@header_userMenu_button_widget:Widgets`;

	parentFundraiserCount: number = 0;
	stripeStatus: any = {};
	stripeNotificationCheck = false;
	showWidgetText: boolean = false;
	showWidgetIcon: boolean = false;

	constructor(
		public router: Router,
		public sidenavService: SidenavService,
		public _dashboardService: DashboardService,
		public _accountService: AccountService,
		public _bankService: BankService,
		public fundraiserService: FundraiserService
	) {}

	ngOnInit(): void {
		this.fundraiserService
			.getUserFundraiserListByApiKey('')
			.subscribe((res: any) => {
				if (!Array.isArray(res.data)) {
					res.data = [];
				}

				if (res.data.length > 0) {
					this.showWidgetIcon = true;
					this.showWidgetText = true;
				}
			});

		this.getActiveItem();
		this.sidenavService.isShowText.subscribe((res: any) => {
			this.isShowText = res;
		});
		this.sidenavService.isShowIcon.subscribe((res: any) => {
			this.isShowIcon = res;
		});

		this._dashboardService.getFundraiserSummary().subscribe((response: any) => {
			this.parentFundraiserCount = response?.data?.parent || 0;
		});

		if (this._accountService.checkHeaders()) {
			/** *Get Stripe Verification Check to Show Notification Bar */
			this._bankService.getStripeStatus().subscribe((res: any) => {
				this.stripeStatus = res?.data;
				//Checking that either user is verified with Stripe or not
				if (
					this.stripeStatus?.charges_enabled == true &&
					this.stripeStatus?.payout_enabled == true &&
					this.stripeStatus?.details_submitted == true
				) {
					this.stripeNotificationCheck = true;
				} else {
					this.stripeNotificationCheck = false;
				}
			});

			this._dashboardService
				.getFundraiserSummary()
				.subscribe((response: any) => {
					this.parentFundraiserCount = response?.data?.parent || 0;
				});
		}
	}

	/*
	 * Function for selected item
	 * @param value
	 */
	getActiveItem() {
		this.router.events.subscribe((e) => {
			if (e instanceof NavigationEnd) {
				if (e.url.includes('/dashboard')) {
					this.activeItem = 'dashboard';
				} else if (e.url.includes('/my-fundraisers')) {
					this.activeItem = 'myFundraisers';
				} else if (e.url.includes('/balance')) {
					this.activeItem = 'balance';
				} else if (e.url.includes('/profile/payout-settings')) {
					this.activeItem = 'payoutSettings';
				} else if (e.url.includes('/profile/email')) {
					this.activeItem = 'emailSettings';
				} else if (e.url.includes('/custom-branding#branding')) {
					this.activeItem = 'customiseFundraisers';
				} else if (e.url.includes('/custom-branding/email')) {
					this.activeItem = 'customiseEmails';
				} else if (e.url.includes('/custom-branding/receipt')) {
					this.activeItem = 'customiseReceipts';
				} else if (e.url.includes('/profile/api')) {
					this.activeItem = 'apiKey';
				} else if (e.url.includes('/custom-domain')) {
					this.activeItem = 'custom-domain';
				} else if (e.url.includes('/fundraising/widget')) {
					this.activeItem = 'widget';
				} else if (e.url.includes('/donations')) {
					this.activeItem = 'donations';
				} else if (e.url.includes('/profile/zapier')) {
					this.activeItem = 'zapier';
				}else if (e.url.includes('/custom-branding/qrcode')) {
					this.activeItem = 'qrCode';
				} else {
					this.activeItem = '';
				}
			}
		});
	}

	/*
	 * Function for user menu clicks
	 * @param value
	 */
	userMenuClick(value: string) {
		this.activeItem = value;
		switch (value.toLowerCase()) {
			case 'dashboard':
				this.router.navigate(['/dashboard']);
				break;
			case 'myfundraisers':
				this.router.navigate(['/my-fundraisers']);
				break;
			case 'balance':
				this.router.navigate(['/balance']);
				break;
			case 'payoutsettings':
				this.router.navigate(['/profile/payout-settings']);
				break;
			case 'emailsettings':
				this.router.navigate(['/profile/email']);
				break;
			case 'customisefundraisers':
				this.routeToBranding();
				break;
			case 'customiseemails':
				this.routeToEmail();
				break;
			case 'custom branding':
				this.router.navigate(['/custom-branding']);
				break;
			case 'customisereceipts':
				this.routeToReceipt();
				break;

			case 'embedplugin':
				this.routeToReceipt();
				break;
			case 'apikey':
				this.router.navigate(['/profile/api']);
				break;
			case 'custom-domain':
				this.router.navigate(['/custom-domain']);
				break;

			case 'zapier':
				this.router.navigate(['/profile/zapier']);
				break;

			case 'widget':
				this.router.navigate(['/fundraising/widget']);
				break;
			case 'donations':
				this.router.navigate(['/donations']);
				break;
			case 'qrcode':
				this.routeToQrCode();
				break;

		}
		if (this.isMobileViewPort()) {
			this.closeSidenav();
		}
	}

	/*
	 * Route to custom branding
	 */
	routeToBranding() {
		const navigationExtras: NavigationExtras = { fragment: 'branding' };
		this.router.navigate(['custom-branding'], navigationExtras);
	}
	/*
	 * Route to customize qr code
	 */
	routeToQrCode() {
		this.router.navigate(['custom-branding/qrcode']);
	}
	/*
	 * Route to custom email
	 */
	routeToEmail() {
		this.router.navigate(['custom-branding/email']);
	}
	/*
	 * Route to custom receipt
	 */
	routeToReceipt() {
		this.router.navigate(['custom-branding/receipt']);
	}

	isMobileViewPort(): Boolean {
		var innerWidth = window.innerWidth;
		if (innerWidth < 420) {
			return true;
		} else {
			return false;
		}
	}

	closeSidenav() {
		// Conditions For Mobile View
		this.isShowText = !this.isShowText;
		this.isShowIcon = !this.isShowIcon;
		this.sidenavService.toggleSidenav(this.isShowText, this.isShowIcon);
	}
}
